export const changeUrl = (url:string) => window.location.assign(url)